import type { InputDateProps } from '@presentation/components';

export interface InputDateFieldProps extends InputDateProps {
  name: string;
  clearable?: boolean;
  disableFutureDates?: boolean;
  disablePastDates?: boolean;
}
